import { Navigate } from "react-router";
import { Loader } from "lucide-react";

import { useMySubscription } from "@/hooks/queries/useMySubscription";
import { getLandingRoute } from "@/lib/landing";

// @ts-ignore
import licitigo_logo from "../../../assets/licitigo_logo.svg";

/**
 * El landing de la app. Va en los dos sitios que mandan al usuario "a la home"
 * (el índice y el catch-all): si solo se toca uno, la vista buena se ve al entrar
 * pero cualquier URL rara rebota al dashboard.
 */
export default function LandingRedirect() {
  const { data: subscription, isPending } = useMySubscription();

  // Sin sesión la consulta falla y `subscription` queda vacío: se cae al
  // dashboard y el AuthGuard manda al login, que es lo correcto.
  if (isPending) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-6">
        <img src={licitigo_logo} alt="Licitigo" className="h-14 w-auto" />
        <Loader className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return <Navigate to={getLandingRoute(subscription)} replace />;
}
